import { Box, Flex, Grid, useTenant } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PageLayout } from "@/shared/layout";
import { usePermission } from "@/shared/permission";
import type { IAuth } from "@/models/Auth";
import { PartnerAlert } from "./components/PartnerAlert";
import { PartnerProfileCard } from "./components/PartnerProfileCard";
import { MainInfoForm } from "./components/forms/mainInfo-form";
import classes from "./PartnerPage.module.css";

export function PartnerPage() {
  const { t } = useTranslation("partner");
  const { t: tCommon } = useTranslation("common");
  const tenant = useTenant();
  const PRT_PRO_MAIN = usePermission("PRT_PRO_MAIN");
  const user = useSelector((state: { auth: IAuth }) => state.auth.user);

  const isCitizen = user?.partner?.type === "CITIZEN";
  const pageTitle = t(isCitizen ? "pageTitleCitizen" : "pageTitle");
  const subTitle = t(isCitizen ? "pageSubtitleCitizen" : "pageSubtitle", { tenant: tenant?.name || "DeHUB" });

  const breadcrumbs = [{ to: "/", label: tCommon("home") }, { label: pageTitle }];

  return (
    <PageLayout title={pageTitle} subTitle={subTitle} breadcrumb={breadcrumbs}>
      {PRT_PRO_MAIN.hasAccess ? (
        <Flex direction="column" gap="md" className={classes.page}>
          <PartnerAlert />
          <Grid gap="md">
            <Grid.Col span={{ base: 12, lg: 4, xl: 3 }}>
              <Box className={classes.stickyProfile}>
                <PartnerProfileCard user={user} />
              </Box>
            </Grid.Col>
            <Grid.Col span={{ base: 12, lg: 8, xl: 9 }}>
              <MainInfoForm />
            </Grid.Col>
          </Grid>
        </Flex>
      ) : (
        PRT_PRO_MAIN.accessDenied()
      )}
    </PageLayout>
  );
}
